import type { InputHTMLAttributes } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  error?: string;
}

export default function FormField({
  label,
  name,
  error,
  ...rest
}: Props): JSX.Element {
  const id = `field-${name}`;
  return (
    <div style={{ marginBottom: "1rem" }}>
      <label
        htmlFor={id}
        style={{ display: "block", marginBottom: 4, fontSize: 14 }}
      >
        {label}
      </label>
      <input
        id={id}
        name={name}
        {...rest}
        style={{
          width: "100%",
          padding: "0.5rem 0.75rem",
          background: "var(--bg)",
          color: "var(--fg)",
          border: `1px solid ${error ? "var(--error)" : "var(--border)"}`,
          borderRadius: 6,
          fontSize: 14,
        }}
      />
      {error ? (
        <div
          role="alert"
          style={{ color: "var(--error)", fontSize: 12, marginTop: 4 }}
        >
          {error}
        </div>
      ) : null}
    </div>
  );
}
